import HighlightClip, { HighlightClipProps } from './HighlightClip';

export default HighlightClip;
export type { HighlightClipProps };
